import { toast } from "react-toastify";
import { SET_USERS_LIST, SET_USERS_TOTAL_PAGE, isLoading } from "../../../constants/actionConstants";
import { userService } from "./service";

export const getItemList = (params) => async (dispatch) => {
    dispatch(isLoading(true));
    let getItemList = await userService.getItemList(params);
    console.log(getItemList)

    dispatch({
        type: SET_USERS_LIST,
        payload: getItemList.data,
    });
    dispatch({
        type: SET_USERS_TOTAL_PAGE,
        payload: getItemList.totalPages,
    })
    dispatch(isLoading(false));
};
export const RegisterSubAdmin = (params) => async (dispatch) => {
    dispatch(isLoading(true));
    let save = await userService.registerSubAdmin(params);
    const { status, message } = save
    if (status) {
        toast.success(message)

    } else {
        toast.error(message)
    }
    dispatch(isLoading(false));
    return save
}

export const UpdateSubAdmin = (id, params) => async (dispatch) => {
    dispatch(isLoading(true));
    let update = await userService.updateSubAdmin(id, params);
    const { status, message } = update

    if (status) {
        toast.success(message)
    }
    dispatch(isLoading(false));
    return update
}
